import { Sport } from '#src/__generated__/globalTypes.ts';

type CardType = 'Card' | 'BaseballCard' | 'NBACard';

export const cardTypes: Record<Sport, CardType> = {
  [Sport.FOOTBALL]: 'Card',
  [Sport.BASEBALL]: 'BaseballCard',
  [Sport.NBA]: 'NBACard',
} as const;
